export default (phone) => {
  const regex = /^\d{10}$/;
  return regex.test(phone);
};
